import PermissionGuard from 'components/Global/PermissionGuard';
import CoaTables from 'components/Settings/Coa';

export const Coa = () => {
	return (
		<PermissionGuard permission="Allow_Chart_of_Accounts">
			<CoaTables />
		</PermissionGuard>
	);
};
